import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	refreshIconLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency.refresh-icon-label',
		defaultMessage: 'Switch issues',
		description: 'Label for the refresh icon which switches the two issues positions',
	},
	filteredOutWarning: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency.filtered-out-warning',
		defaultMessage:
			"This dependency will be created, but won't be visible due to the applied filters.",
		description:
			'The warning message displayed when the user is creating an dependencies on issues that are filtered out in the dependency report.',
	},
	selectSourceIssue: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency.select-source-issue',
		defaultMessage: 'Select source issue',
		description:
			'Aria-label for the input field in the Add Dependency dialog, used to identify the originating issue of the new dependency.',
	},
	selectDependencyType: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency.select-dependency-type',
		defaultMessage: 'Select dependency type',
		description:
			'Aria-label for the input field in the Add Dependency dialog, used to identify the dependency type.',
	},
	selectTargetIssue: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency.select-target-issue',
		defaultMessage: 'Select target issue',
		description:
			'Aria-label for the input field in the Add Dependency dialog, used to identify the issue that the new dependency points to.',
	},
	addDependencyDialogAriaLabelText: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency.add-dependency-dialog-aria-label-text',
		defaultMessage: 'Add dependency dialog',
		description:
			'Aria-label for the Add Dependency dialog, used to identify the pop up while clicking add dependency button',
	},
});
